module.exports = __webpack_public_path__ + "img/086f7a1.jpg";